import { useEffect, useState } from "react";

import styled from "styled-components";

import { deleteComment, postComment } from "../../api/commentAPI";
import { checkUserName } from "../../api/authAPI";

interface Props {
  postId: number;
  comments: Array<{ commentId: number; content: string; name: string }>;
  reloadComments: () => void;
}

const CommentsArea = ({ postId, comments, reloadComments }: Props) => {
  const [newComment, setNewComment] = useState("");
  const [userName, setUserName] = useState<string | null>(null);

  const handleCommentSubmit = async () => {
    if (!newComment) return;

    const result = await postComment(postId, newComment);
    if (result) {
      setNewComment("");
      reloadComments();
    }
  };

  const handleDeleteComment = async (commentId: number) => {
    const result = await deleteComment(commentId);
    reloadComments();
  };

  useEffect(() => {
    checkUserName().then((name) => setUserName(name));
  }, [ comments ])

  return (
    <StCommentsAreaContainer>
      <div style={{ padding: "16px", display: "flex", flexDirection: "column", gap: "12px", height: "100%", overflowY: "auto" }}>
        <h3 style={{ margin: 0 }}>Comments</h3>
        {comments.map((comment) => (
          <StCommentItem key={comment.commentId}>
            <div style={{ fontSize: "16px", fontWeight: "bold", marginBottom: "4px" }}>{comment.name}</div>
            {userName === comment.name &&
            <button
                onClick={() => {
                  handleDeleteComment(comment.commentId);
                }}
                style={{
                  padding: "4px 8px",
                  backgroundColor: "#ff4d4f",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "12px",
                  float: "right"
                }}
              >
                Delete
              </button>}
            <div style={{ fontSize: "18px" }}>{comment.content}</div>
          </StCommentItem>
        ))}
        <div style={{ display: "flex", gap: "8px", marginBottom: "12px" }}>
          <input
            type="text"
            placeholder="Add a comment..."
            value={newComment}
            onChange={(e) => setNewComment(e.target.value)}
            style={{
              flex: 1,
              padding: "8px 12px",
              border: "1px solid #d9d9d9",
              borderRadius: "4px",
              fontSize: "14px"
            }}
          />
          <button
            onClick={handleCommentSubmit}
            style={{
              padding: "8px 16px",
              backgroundColor: "#1890ff",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer"
            }}
          >
            Send
          </button>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          {[].map((comment, idx) => (
            <div
              key={idx}
              style={{
                padding: "12px",
                backgroundColor: "#f5f5f5",
                borderRadius: "4px",
                borderLeft: "3px solid #1890ff"
              }}
            >
              <div style={{ fontWeight: "bold", fontSize: "12px", marginBottom: "4px" }}>User</div>
              <div style={{ fontSize: "14px" }}>Comment text</div>
            </div>
          ))}
        </div>
      </div>
    </StCommentsAreaContainer>
  );
};

const StCommentsAreaContainer = styled.div`
  padding: 16px;
  height: 400px;
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
`;

const StCommentItem = styled.div`
  padding: 8px;
  width: 100%;
  margin: 0 auto;
  border: 1px solid #d0d0d0;
`;

export default CommentsArea;